import { SearchUsers } from '@platform/client';
import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { AuthedPage, HeaderFooterLayout } from '../../app';
import { LanguageSelectionDropdown } from '../../components/LanguageSelectionDropdown';
import { PaginationBar } from '../../components/PaginationBar';
import { SkillCategorySelectionDropdown } from '../../components/SkillCategorySelectionDropdown';
import { UserCard } from './UserCard';

const UserPageSize = 50;

const UserSearch = () => {
  const [languageSelection, setLanguageSelection] = useState<string[]>([]);
  const [skillCategorySelection, setSkillCategorySelection] = useState<string[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(0);

  const userData = SearchUsers.useSearchProUsers({
    languages: languageSelection.join(';'),
    skills: skillCategorySelection.join(';'),
    page: currentPage,
    limit: UserPageSize,
  });

  const numUsers = userData.data?.filteredCount || 0;
  const numPages = Math.ceil(numUsers / UserPageSize);

  const onPageSelect = (page: number) => {
    setCurrentPage(page - 1);
  };

  return (
    <AuthedPage>
      <HeaderFooterLayout useDashboardHeader>
        <div className='flex flex-col gap-4 px-4 py-6 md:px-6 w-full'>
          <div className='text-4xl font-semibold text-gray-900'>
            Find a professional to help with your project
          </div>
          <div className='flex flex-col md:flex-row md:gap-4 text-lg'>
            <div className='w-[350px] p-2 mx-auto md:mx-0'>
              <LanguageSelectionDropdown
                selectedLanguages={languageSelection}
                onLanguageSelectionChange={setLanguageSelection}
                label='Languages'
              />
            </div>
            <div className='w-[350px] p-2 mx-auto md:mx-0'>
              <SkillCategorySelectionDropdown
                selectedCategories={skillCategorySelection}
                onCategorySelectionChange={setSkillCategorySelection}
                label='Skills category'
                placeholder='Select skills category'
              />
            </div>
          </div>
          {userData.isSuccess && (
            <div className='grid grid-cols-1 md:grid-cols-3 bg-gray-50 gap-6 pt-4 pb-10 px-4'>
              {userData.data.users.map((user) => {
                return <UserCard user={user} key={user.id} />;
              })}
            </div>
          )}
          {!userData.isSuccess && <Skeleton />}
          <PaginationBar
            numPages={numPages}
            currentPage={currentPage + 1}
            onPageSelect={onPageSelect}
          />
        </div>
      </HeaderFooterLayout>
    </AuthedPage>
  );
};

export default UserSearch;
